var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ins',{staticClass:"hidden-string",class:{reveal:_vm.reveal},on:{"click":function($event){_vm.reveal = !_vm.reveal}}},[_vm._v("\n    "+_vm._s(_vm.result)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }